import StyledTextField from "../../../common/components/styled-components/StyledTextField";
import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, FormControl, MenuItem } from '@mui/material';
import styles from "../LPSForm.styles";
import { lpsFormTypes } from "../../../common/constants/field-constants";
import { selectSearch } from "../../search/selectors";
import { connect, useDispatch } from "react-redux";
import { receiveCityRequest } from "../../search/actions/search";
import { RootState } from '../../../reducers';
import { StyledInputLabel, StyledSelect } from '../../../common/components/styled-components/StyledSelect';
import { SelectChangeEvent } from '@mui/material/Select';
// import { LatinTextField } from '../../../common/components/latin-text-field/LatinTextField';
// import { selectLPS } from '../selectors';

interface CityOptions {
  cityId: number;
  nameCity: string;
  configCityId?: number;
}

const calculationOptions = [
  {
    label: "Industrial",
    value: "industrial",
  },
  {
    label: "Non-industrial",
    value: "non-industrial",
  },
  {
    label: "Kadaster",
    value: "kadaster",
  },
];

const configOptions = [
  {
    label: "Public",
    value: "public",
  },
  {
    label: "Private",
    value: "private",
  },
];

const objectOptions = [
  {
    label: "G0",
    value: "G0",
  },
  {
    label: "A",
    value: "A",
  },
  {
    label: "All items",
    value: "all",
  },
];

const entityOptions = [
  {
    label: "All entities",
    value: "all_ent",
  },
  {
    label: "Without blacklisted",
    value: "exclude_blacklisted",
  },
];

const LPSGeneralFieldsBlock = ({
  onChange,
  calculationType,
  generalFields,
  citiesResult,
  actionChangeCity,
  resetForm,
  configLpsCities,
  processing,
  isFilledFields,
  changeFilledFields,
  error,
  handlerBlurName,
  idLPS,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [optionsForCitiesGroup, setOptionsForCitiesGroup] = useState<CityOptions[]>([]);
  const [inputMultipleValue, setInputMultipleValue] = useState("");
  const [multipleValue, setMultipleValue] = useState<CityOptions[]>([]);
  const isEditMode = Boolean(idLPS);

  useEffect(() => {
    const filterLpsConfigCities = configLpsCities.map((item) => {
      return {
        cityId: item.city_id,
        nameCity: item.city_name,
        configCityId: item.id,
      };
    });
    setMultipleValue(filterLpsConfigCities);
    // setMultipleValue(configLpsCities)
  }, [configLpsCities]);

  useEffect(() => {
    let dynamic = true;
    let newMultipleOptions: CityOptions[] = [];

    if (inputMultipleValue === "") {
      setOptionsForCitiesGroup(multipleValue ? [...multipleValue] : []);
      return undefined;
    }

    if (dynamic) {
      if (multipleValue) {
        newMultipleOptions = multipleValue;
      }
      if (citiesResult) {
        const optionCityResult = citiesResult.map((city) => ({
          cityId: city.id,
          nameCity: city.city,
        }));
        newMultipleOptions = [...newMultipleOptions, ...optionCityResult];
      }
      setOptionsForCitiesGroup(newMultipleOptions);
    }

    return () => {
      dynamic = false;
    };
  }, [dispatch, citiesResult, multipleValue, inputMultipleValue]);

  useEffect(() => {
    if (!!Object.keys(isFilledFields).length) {
      changeFilledFields({ ...isFilledFields, isFilledFieldCity: true });
    }
    // if (multipleValue.length === 0) {
    //   actionChangeCity(multipleValue);
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multipleValue]);

  useEffect(() => {
    if (resetForm) {
      setMultipleValue([]);
    }
  }, [resetForm]);

  useEffect(() => {
    if (generalFields.name) {
      changeFilledFields({ ...isFilledFields, isFilledFieldName: true, isNotDuplicatedFieldName: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalFields.name]);

  useEffect(() => {
    if (generalFields.config_type) {
      changeFilledFields({ ...isFilledFields, isFilledFieldConfigType: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalFields.config_type]);

  useEffect(() => {
    if (generalFields.object_type) {
      changeFilledFields({ ...isFilledFields, isFilledFieldObjectType: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalFields.object_type]);

  useEffect(() => {
    if (generalFields.entity_type) {
      changeFilledFields({ ...isFilledFields, isFilledFieldEntityType: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalFields.entity_type]);

  useEffect(() => {
    if (!open && multipleValue !== null) {
      setOptionsForCitiesGroup([]);
    }
  }, [open, multipleValue]);

  const shallowEqualityCheck = (obj1: any, obj2: any) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  };

  const handleMultipleChange = (newInputMultipleValue: any) => {
    setInputMultipleValue(newInputMultipleValue);

    if (newInputMultipleValue.length >= 2) {
      const requestData = {
        inputValue: newInputMultipleValue,
      };
      dispatch(receiveCityRequest(requestData));
    }
  };

  const comparingOptionAndValue = (option, value) => {
    if (Array.isArray(option)) {
      return option.some((item) => shallowEqualityCheck(item, value));
    } else {
      return option === value;
    }
  };

  return (
    <Box sx={styles.fieldHolder}>
      <Box sx={styles.fieldBlock}>
        <FormControl
          fullWidth
          required
          disabled={isEditMode}
          margin="dense"
        >
          <StyledInputLabel
            id="select-calculation-type-label"
            htmlFor="select-calculation-type-input"
            sx={{
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "1rem",
              }
            }}
          >
            Calculation type
          </StyledInputLabel>
          <StyledSelect
            labelId="select-calculation-type-label"
            id="select-calculation-type"
            name="selectCalculationType"
            value={generalFields?.calculation_type || ""}
            label="Calculation type"
            onChange={(event: SelectChangeEvent) =>  onChange("generalFields", "calculation_type", event)}
            sx={styles.inputTextField}
            inputProps={{
              id: 'select-calculation-type-input',
            }}
          >
            {calculationOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
        {/*<StyledTextField*/}
        {/*  fullWidth*/}
        {/*  required*/}
        {/*  select*/}
        {/*  label="Calculation type"*/}
        {/*  disabled={isEditMode}*/}
        {/*  margin="dense"*/}
        {/*  defaultValue=""*/}
        {/*  sx={styles.inputTextField}*/}
        {/*  slotProps={{*/}
        {/*    inputLabel: {*/}
        {/*      sx: {*/}
        {/*        fontSize: {*/}
        {/*          xs: "12px",*/}
        {/*          sm: "14px",*/}
        {/*          md: "1rem",*/}
        {/*        },*/}
        {/*      },*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  onChange={(e) => onChange("generalFields", "calculation_type", e)}*/}
        {/*  value={generalFields?.calculation_type || ""}*/}
        {/*>*/}
        {/*  {calculationOptions.map((option) => (*/}
        {/*    <MenuItem key={option.value} value={option.value}>*/}
        {/*      {option.label}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</StyledTextField>*/}
        {calculationType === lpsFormTypes.NON_INDUSTRIAL ? (
          <Autocomplete
            multiple
            open={open && inputMultipleValue.length >= 2}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            options={optionsForCitiesGroup}
            loading={processing}
            filterOptions={(x) => x}
            autoComplete
            value={multipleValue}
            includeInputInList
            filterSelectedOptions
            blurOnSelect
            fullWidth
            getOptionLabel={(option) => {
              return option.nameCity;
            }}
            isOptionEqualToValue={(option, value) => {
              return comparingOptionAndValue(option, value);
            }}
            onChange={(_e, newValue, reason) => {
              let nextValue: any[] = [];
              if (reason === "removeOption" || reason === "clear") {
                nextValue = (newValue ?? []) as any[]
              } else {
                const citiesIds = new Set<number>();
                nextValue = (newValue ?? []).filter((item:any) => {
                  if (citiesIds.has(item.cityId)) {
                    return false;
                  }
                  citiesIds.add(item.cityId);
                  return true;
                });
              }
              setOptionsForCitiesGroup(
                newValue && newValue.length
                    ? [...newValue, ...optionsForCitiesGroup]
                    : optionsForCitiesGroup
              );
              setMultipleValue(nextValue);
              actionChangeCity(nextValue);

              // const cities = new Set(
              //   multipleValue.map((multiple: any) => multiple.city)
              // );
              // setOptionsForCitiesGroup(
              //   newValue
              //     ? [newValue, ...optionsForCitiesGroup]
              //     : optionsForCitiesGroup
              // );
              // // @ts-ignore
              // setMultipleValue([
              //   ...multipleValue,
              //   ...newValue.filter((o) => !cities.has(o.city)),
              // ]);
              // if (reason === "removeOption" || reason === "clear") {
              //   // @ts-ignore
              //   setMultipleValue([...newValue]);
              // }
            }}
            onInputChange={(_e, newInputMultipleValue) =>
              handleMultipleChange(newInputMultipleValue)
            }
            renderInput={(params) => (
              <StyledTextField
                {...params}
                required
                name="generalFieldsLPSCity"
                error={
                  !!Object.keys(isFilledFields).length &&
                  !isFilledFields.isFilledFieldCity &&
                  isFilledFields.isFilledFieldCity !== undefined
                }
                label="City"
                sx={styles.inputTextField}
                slotProps={{
                  inputLabel: {
                    sx: {
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      },
                    },
                  },
                }}
                margin="dense"
              />
            )}
          />
        ) : (
          <StyledTextField
            fullWidth
            disabled
            label="City"
            sx={styles.inputTextField}
            slotProps={{
              inputLabel: {
                sx: {
                  fontSize: {
                    xs: "12px",
                    sm: "14px",
                    md: "1rem",
                  },
                },
              },
            }}
            margin="dense"
            onChange={(e) => onChange("generalFields", "city", e)}
            value={generalFields?.city}
          />
        )}
      </Box>
      <Box sx={styles.fieldBlock}>
        <StyledTextField
          fullWidth
          required
          error={
            ((!!Object.keys(isFilledFields).length &&
            !isFilledFields.isFilledFieldName &&
            isFilledFields.isFilledFieldName !== undefined) ||
            (!!Object.keys(isFilledFields).length &&
            !isFilledFields.isNotDuplicatedFieldName &&
            isFilledFields.isNotDuplicatedFieldName !== undefined)) || !!error
          }
          label="Config name"
          sx={styles.inputTextField}
          slotProps={{
            inputLabel: {
              sx: {
                fontSize: {
                  xs: "12px",
                  sm: "14px",
                  md: "1rem",
                },
              },
            },
          }}
          margin="dense"
          onChange={(e) => onChange("generalFields", "name", e)}
          onBlur={handlerBlurName}
          value={generalFields?.name}
        />
        <FormControl
          fullWidth
          required
          error={
            !!Object.keys(isFilledFields).length &&
            !isFilledFields.isFilledFieldConfigType &&
            isFilledFields.isFilledFieldConfigType !== undefined
          }
          margin="dense"
        >
          <StyledInputLabel
            id="select-config-type-label"
            htmlFor="select-config-type-input"
            sx={{
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "1rem",
              }
            }}
          >
            Config type
          </StyledInputLabel>
          <StyledSelect
            labelId="select-config-type-label"
            id="select-config-type"
            name="selectConfigType"
            value={generalFields?.config_type || ""}
            label="Config type"
            onChange={(event: SelectChangeEvent) =>  onChange("generalFields", "config_type", event)}
            sx={styles.inputTextField}
            inputProps={{
              id: 'select-config-type-input',
            }}
          >
            {configOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
        {/*<StyledTextField*/}
        {/*  fullWidth*/}
        {/*  error={*/}
        {/*    !!Object.keys(isFilledFields).length &&*/}
        {/*    !isFilledFields.isFilledFieldConfigType &&*/}
        {/*    isFilledFields.isFilledFieldConfigType !== undefined*/}
        {/*  }*/}
        {/*  required*/}
        {/*  select*/}
        {/*  label="Config type"*/}
        {/*  sx={styles.inputTextField}*/}
        {/*  slotProps={{*/}
        {/*    inputLabel: {*/}
        {/*      sx: {*/}
        {/*        fontSize: {*/}
        {/*          xs: "12px",*/}
        {/*          sm: "14px",*/}
        {/*          md: "1rem",*/}
        {/*        },*/}
        {/*      },*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  margin="dense"*/}
        {/*  defaultValue=""*/}
        {/*  onChange={(e) => onChange("generalFields", "config_type", e)}*/}
        {/*  value={generalFields?.config_type || ""}*/}
        {/*>*/}
        {/*  {configOptions.map((option) => (*/}
        {/*    <MenuItem key={option.value} value={option.value}>*/}
        {/*      {option.label}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</StyledTextField>*/}
      </Box>
      <Box sx={styles.fieldBlock}>
        <FormControl
          fullWidth
          required
          disabled
          error={
            !!Object.keys(isFilledFields).length &&
            !isFilledFields.isFilledFieldObjectType &&
            isFilledFields.isFilledFieldObjectType !== undefined
          }
          margin="dense"
        >
          <StyledInputLabel
            id="select-objects-type-label"
            htmlFor="select-objects-type-input"
            sx={{
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "1rem",
              }
            }}
          >
            Objects type
          </StyledInputLabel>
          <StyledSelect
            labelId="select-objects-type-label"
            id="select-objects-type"
            name="selectObjectsType"
            value={generalFields?.object_type || ""}
            label="Objects type"
            onChange={(event: SelectChangeEvent) =>  onChange("generalFields", "object_type", event)}
            sx={styles.inputTextField}
            inputProps={{
              id: 'select-objects-type-input',
            }}
          >
            {objectOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
        {/*<StyledTextField*/}
        {/*  fullWidth*/}
        {/*  disabled*/}
        {/*  error={*/}
        {/*    !!Object.keys(isFilledFields).length &&*/}
        {/*    !isFilledFields.isFilledFieldObjectType &&*/}
        {/*    isFilledFields.isFilledFieldObjectType !== undefined*/}
        {/*  }*/}
        {/*  required*/}
        {/*  select*/}
        {/*  label="Objects type"*/}
        {/*  sx={styles.inputTextField}*/}
        {/*  slotProps={{*/}
        {/*    inputLabel: {*/}
        {/*      sx: {*/}
        {/*        fontSize: {*/}
        {/*          xs: "12px",*/}
        {/*          sm: "14px",*/}
        {/*          md: "1rem",*/}
        {/*        },*/}
        {/*      },*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  margin="dense"*/}
        {/*  defaultValue=""*/}
        {/*  onChange={(e) => onChange("generalFields", "object_type", e)}*/}
        {/*  value={generalFields?.object_type || ""}*/}
        {/*>*/}
        {/*  {objectOptions.map((option) => (*/}
        {/*    <MenuItem key={option.value} value={option.value}>*/}
        {/*      {option.label}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</StyledTextField>*/}
        <FormControl
          fullWidth
          required
          disabled
          error={
            !!Object.keys(isFilledFields).length &&
            !isFilledFields.isFilledFieldEntityType &&
            isFilledFields.isFilledFieldEntityType !== undefined
          }
          margin="dense"
        >
          <StyledInputLabel
            id="select-entities-type-label"
            htmlFor="select-entities-type-input"
            sx={{
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "1rem",
              }
            }}
          >
            Entities type
          </StyledInputLabel>
          <StyledSelect
            labelId="select-entities-type-label"
            id="select-entities-type"
            name="selectEntitiesType"
            value={generalFields?.entity_type || ""}
            label="Entities type"
            onChange={(event: SelectChangeEvent) =>  onChange("generalFields", "entity_type", event)}
            sx={styles.inputTextField}
            inputProps={{
              id: 'select-entities-type-input',
            }}
          >
            {entityOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
        {/*<StyledTextField*/}
        {/*  fullWidth*/}
        {/*  disabled*/}
        {/*  error={*/}
        {/*    !!Object.keys(isFilledFields).length &&*/}
        {/*    !isFilledFields.isFilledFieldEntityType &&*/}
        {/*    isFilledFields.isFilledFieldEntityType !== undefined*/}
        {/*  }*/}
        {/*  required*/}
        {/*  select*/}
        {/*  label="Entities type"*/}
        {/*  sx={styles.inputTextField}*/}
        {/*  slotProps={{*/}
        {/*    inputLabel: {*/}
        {/*      sx: {*/}
        {/*        fontSize: {*/}
        {/*          xs: "12px",*/}
        {/*          sm: "14px",*/}
        {/*          md: "1rem",*/}
        {/*        },*/}
        {/*      },*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  margin="dense"*/}
        {/*  defaultValue=""*/}
        {/*  onChange={(e) => onChange("generalFields", "entity_type", e)}*/}
        {/*  value={generalFields?.entity_type || ""}*/}
        {/*>*/}
        {/*  {entityOptions.map((option) => (*/}
        {/*    <MenuItem key={option.value} value={option.value}>*/}
        {/*      {option.label}*/}
        {/*    </MenuItem>*/}
        {/*  ))}*/}
        {/*</StyledTextField>*/}
      </Box>
    </Box>
  );
};

function mapStateToProps(state: RootState) {
  const { citiesResult, processing } = selectSearch(state);
  return { citiesResult, processing };
}

export default connect(mapStateToProps)(LPSGeneralFieldsBlock);
